import React from "react";
import { Container } from "react-bootstrap";
import { useInView } from "react-intersection-observer";
import { useSpring, animated } from "react-spring";

const categoryIcons = {
  "Languages": "{ }",
  "Web & API": "</>",
  "Cloud & DevOps": "⚙",
  "Data & ML": "∑",
  "Databases & Storage": "⊞",
  "Monitoring & Testing": "◎",
};

const CategoryCard = ({ category, skills }) => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.1 });
  const spring = useSpring({
    opacity: inView ? 1 : 0,
    transform: inView ? "translateY(0px)" : "translateY(20px)",
    config: { tension: 200, friction: 30 },
  });

  return (
    <animated.div ref={ref} style={spring} className="skill-category-card">
      <div className="skill-category-header">
        <span className="skill-category-icon">{categoryIcons[category] || "•"}</span>
        <h5 className="skill-category-title">{category}</h5>
      </div>
      <div className="skill-tags">
        {skills.map((skill, i) => (
          <span key={i} className="skill-tag">{skill.name}</span>
        ))}
      </div>
    </animated.div>
  );
};

const Skills = React.forwardRef(({ heading, technicalSkills }, ref) => {
  const [headerRef, headerInView] = useInView({ triggerOnce: true });
  const headerSpring = useSpring({
    opacity: headerInView ? 1 : 0,
    transform: headerInView ? "translateY(0)" : "translateY(-20px)",
  });

  return (
    <section ref={ref} id="skills" className="skills-section">
      <Container>
        <animated.div ref={headerRef} style={headerSpring}>
          <h2 className="display-4 pb-5 text-center">{heading}</h2>
        </animated.div>

        <div className="skill-grid">
          {technicalSkills.map((cat, i) => (
            <CategoryCard key={i} category={cat.category} skills={cat.skills} />
          ))}
        </div>
      </Container>
    </section>
  );
});

export default Skills;
